<template>
  <div class="point">
    <el-form
      :inline="true"
      label-position="left"
      class="demo-form-inline"
      :model="form"
    >
      <el-form-item label="">
        <el-select
          filterable
          placeholder="点位类型"
          clearable
          style="width: 120px;"
          v-model="form.pointType"
        >
          <el-option
            v-for="item in pointTypeOptions"
            :key="item.id"
            :label="item.typeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          filterable
          placeholder="所属社区"
          clearable
          style="width: 144px;"
          v-model="communityCode"
          @change="commcommunityChange"
        >
          <el-option
            v-for="item in commcommunityList"
            :key="item.code"
            :label="item.pointName"
            :value="item.id + '-' + item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          filterable
          placeholder="所属网格"
          clearable
          style="width: 144px;"
          v-model="form.blockCode"
        >
          <el-option
            v-for="item in blockList"
            :key="item.code"
            :label="item.pointName"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="form.pointName"
          clearable
          placeholder="请输入点位名称"
          style="width:428px;"
        >
          <el-button
            style=" background: #0495FF;
                          border-radius: 0px 4px 4px 0px;
                          color: #FFFFFF;"
            slot="append"
            icon="el-icon-search"
            @click="getPointLevelListPageFun"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="table-top-btns">
      <div class="left-btn">
        <div class="select-number">
          当前选中
          <span style="color: #3666EA;">{{ selectedIdOptions.length }}</span>
          条
        </div>
      </div>
    </div>
    <common-table
      :select="true"
      :isShowPagination="false"
      :dataList="dataList"
      :selectedIdOptions="selectedIdOptions"
      :maxHeight="380"
      @handleSelectionChange="handleSelectionChange"
      @selectAll="selectAll"
    >
      <template v-slot:pointTypes="{ scope }">
        <span>{{ getPointTypeName(scope.row.pointTypes) }}</span>
      </template>
    </common-table>
  </div>
</template>

<script>
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import { getPointLevelListPage } from "@/api/point.js";
import index from "@/mixins/index.js";
export default {
  components: {
    commonTable
  },
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [pageChangeSelect, index],
  data() {
    return {
      communityCode:"",
      form: {
        pointName: "",
        pointType: "",
        communityCode: "",
        blockCode: ""
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointName",
            label: "点位名称"
          },
          {
            slot: "pointTypes",
            label: "点位类型"
          },
          {
            prop: "levelName2",
            label: "所属社区"
          },
          {
            prop: "levelName3",
            label: "所属网格"
          }
        ]
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      }
    };
  },
  mounted() {
    this.selectedIdOptions = this.pointInfo.selectedIdOptions || [];
    this.getCommcommunityAllFun();
    this.getPointTypeListPageFun();
    this.getPointLevelListPageFun();
  },
  methods: {
    nextStepsFun() {
      let pointInfo = {
        selectedOptions: [],
        selectedIdOptions: []
      };
      if (!this.selectedOptions.length) {
        this.$message({
          type: "error",
          message: "请先选择点位"
        });
        return;
      }
      pointInfo.selectedOptions = this.selectedOptions.map(item => {
        return {
          pointName: item.pointName,
          pointType: item.pointType,
          communityCode: item.communityCode,
          blockCode: item.blockCode,
          pointLevelId: item.id
        };
      });
      pointInfo.selectedIdOptions = this.selectedIdOptions;
      this.$emit("updatePointsData", pointInfo);
    },
    // 分页查询
    async getPointLevelListPageFun() {
      let params = {
        page: 1,
        size: 99999,
        ...this.form
      };
      const res = await getPointLevelListPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.point {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/point.vue